import { useProjectSettingsContext } from "components/Settings/SettingsProvider";

import type { Command } from "../../types";

export const useProjectSettingsCommand = (): Command => {
  const { setVisibility } = useProjectSettingsContext();

  return {
    id: "codesandbox.settings.project",
    name: "Open Project Settings",
    section: "Settings",
    perform: () => {
      setVisibility(true);
    },
  };
};
